const AccountManagement = () => 
  import(/* webpackChunkName: 'AccountManagement' */ '@/AccountManagement/AccountManagement');


const ProfileInformation = () => 
  import(/* webpackChunkName: 'ProfileInformation' */ '@/AccountManagement/components/ProfileInformation');

const AccountSettings = () => 
  import(/* webpackChunkName: 'AccountSettings' */ '@/AccountManagement/components/AccountSettings');

const Contacts = () => 
  import(/* webpackChunkName: 'Contacts' */ '@/AccountManagement/components/Contacts');

const Teams = () => 
  import(/* webpackChunkName: 'Teams' */ '@/AccountManagement/components/Teams');

const LeadRouting = () => 
  import(/* webpackChunkName: 'LeadRouting' */ '@/AccountManagement/components/LeadRouting');

const SubaccountManagement = () => 
  import(/* webpackChunkName: 'SubaccountManagement' */ '@/AccountManagement/components/SubaccountManagement');

const Addons = () => 
  import(/* webpackChunkName: 'Addons' */ '@/AccountManagement/components/Addons');


const Integrations = () => 
  import(/* webpackChunkName: 'Integrations' */ '@/AccountManagement/components/Integrations');

const Billing = () => 
  import(/* webpackChunkName: 'Billing' */ '@/AccountManagement/components/Billing');


export default [
  {
    path: '/account_management',
    name: 'account_management',
    component: AccountManagement,
    meta: { auth: true },
    children: [
      {
        path: '',
        redirect: { name: 'account_management_profile' },
        component: ProfileInformation
      },
      {
        path: 'profile',
        name: 'account_management_profile',
        component: ProfileInformation
      },
      {
        path: 'settings',
        name: 'account_management_settings',
        component: AccountSettings
      },
      {
        path: 'contacts',
        name: 'account_management_contacts',
        component: Contacts
      },
      {
        path: 'teams',
        name: 'account_management_teams',
        component: Teams
      },
      {
        path: 'lead_routing',
        name: 'account_management_lead_routing',
        component: LeadRouting
      },
      {
        path: 'subaccount',
        name: 'account_management_subaccount',
        component: SubaccountManagement
      },
      {
        path: 'addons',
        name: 'account_management_addons',
        component: Addons
      },
      {
        path: 'integrations',
        name: 'account_management_integrations',
        component: Integrations
      },
      {
        path: 'billing',
        name: 'account_management_billing',
        component: Billing
      },
    ]
  },
];
